import { Field, FieldLabel } from '@playbooks/ui/components/field';
import { Input } from '@playbooks/ui/components/input';
import { Link } from '@playbooks/ui/components/link';

const LoginFields = ({ user, setUser }) => {
	// Render
	return (
		<>
			<Field>
				<FieldLabel>Email Address</FieldLabel>
				<Input
					size='lg'
					value={user.email || ''}
					placeholder='Email address'
					onChange={e => setUser({ ...user, email: e.target.value })}
				/>
			</Field>

			<Field>
				<div className='flex-between gap-3'>
					<FieldLabel>Password</FieldLabel>
					<Link
						variant='link'
						href='/forgot-password'
						className='h-auto !w-auto p-0 text-xs font-normal text-action hover:text-action-hover'>
						Forgot password?
					</Link>
				</div>
				<Input
					size='lg'
					type='password'
					value={user.password || ''}
					placeholder='••••••••'
					onChange={e => setUser({ ...user, password: e.target.value })}
				/>
			</Field>
		</>
	);
};

export { LoginFields };
